import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "flex items-center mb-4 space-x-1.5"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons inline-icon text-primary" }, " auto_awesome ", -1)
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "w-8 h-8 pt-0.5 pl-1.5 mr-3 -mt-0.5 rounded-full bg-primary bg-opacity-20" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-xl text-primary material-icons-outlined icon-light" }, " article ")
], -1)
const _hoisted_6 = {
  key: 1,
  class: "flex items-center my-4 space-x-1.5"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons inline-icon text-primary" }, " article ", -1)
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "w-8 h-8 pt-0.5 pl-1.5 mr-3 -mt-0.5 rounded-full bg-primary bg-opacity-20" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-xl text-primary material-icons-outlined icon-light" }, " article ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HelpCenterArticleFull = _resolveComponent("HelpCenterArticleFull")!
  const _component_DraggablePopup = _resolveComponent("DraggablePopup")!
  const _directive_wave = _resolveDirective("wave")!

  return (_openBlock(), _createBlock(_component_DraggablePopup, {
    whiteBg: true,
    dragOnTitleOnly: true,
    initialTop: 60,
    initialLeft: _ctx.mediaQueryMdMatches ? 56.5 : 10,
    onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close'))),
    title: _ctx.$t('help.help_center_title'),
    inForeground: true
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "mt-3",
        style: _normalizeStyle('max-height:' + (_ctx.mediaQueryMdMatches ? '30' : '15') + 'rem')
      }, [
        (_ctx.metaStore.helpCenterSelectedArticleId === null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_ctx.relevantArticles.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _hoisted_3,
                    _createElementVNode("h4", null, _toDisplayString(_ctx.$t("help.based_on_your_activity")), 1)
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.relevantArticles, (article) => {
                return _withDirectives((_openBlock(), _createElementBlock("div", {
                  onClick: ($event: any) => (_ctx.metaStore.setHelpCenterArticleId(article.id)),
                  class: "flex px-2 py-2 ml-1.5 transition-colors cursor-pointer items-top duration75 hover:bg-light",
                  key: 'art-' + article.id + '-relevant'
                }, [
                  _hoisted_5,
                  _createElementVNode("p", null, _toDisplayString(article.title), 1)
                ], 8, _hoisted_4)), [
                  [_directive_wave]
                ])
              }), 128)),
              (_ctx.irrelevantArticles.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _hoisted_7,
                    _createElementVNode("h4", null, _toDisplayString(_ctx.$t("help.articles")), 1)
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.irrelevantArticles, (article) => {
                return _withDirectives((_openBlock(), _createElementBlock("div", {
                  onClick: ($event: any) => (_ctx.metaStore.setHelpCenterArticleId(article.id)),
                  class: "flex px-2 py-2 ml-1.5 transition-colors cursor-pointer items-top duration75 hover:bg-light",
                  key: 'art-' + article.id + '-relevant'
                }, [
                  _hoisted_9,
                  _createElementVNode("p", null, _toDisplayString(article.title), 1)
                ], 8, _hoisted_8)), [
                  [_directive_wave]
                ])
              }), 128))
            ]))
          : (_openBlock(), _createBlock(_component_HelpCenterArticleFull, {
              key: 1,
              article: _ctx.selectedArticle,
              onBack: _cache[0] || (_cache[0] = ($event: any) => (_ctx.metaStore.setHelpCenterArticleId(null))),
              allowGoBack: _ctx.allowGoBack
            }, null, 8, ["article", "allowGoBack"]))
      ], 4)
    ]),
    _: 1
  }, 8, ["initialLeft", "title"]))
}